import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { UserIcon2 } from '../components/shared/Icons';
import Dashboard from './Dashboard';
import StaffActivation from './StaffActivation';
import OnboardNonActive from './OnboardNonActive';
import ActiveReplacements from './ActiveReplacements';




const TABS = [
  {
    id: 'dashboardmain',
    label: 'Dashboard',
  },
  
];







  const DASHBOARDSUPERVISOR_INNER = [
  { id: 'dashboadall', label: 'Main Dashboard', icon: <UserIcon2 />, component: Dashboard },
   { id: 'activateall', label: 'Final Activation', icon: <UserIcon2 />, component: StaffActivation },
  { id: 'onboardactive', label: 'Onboarding', icon: <UserIcon2 />, component: OnboardNonActive },
  { id: 'replacementactive', label: 'Replacement', icon: <UserIcon2 />, component: ActiveReplacements },
  
];

const FiltersAdminPage2 = () => {
  
  const [activeTab, setActiveTab] = useState('dashboardmain');
  const { homeAccent } = useUser();

  
  

  


  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
       {activeTab === 'dashboardmain' && <InnerTabsd tabs={DASHBOARDSUPERVISOR_INNER} defaultId="dashboadall"/>}
        
      </div>
    </div>
  );
};



export default FiltersAdminPage2;